import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import PropTypes from 'prop-types';

import Colors from '../../constants/Colors';

/**
 * SearchEmptyState - Displays when search returns no results
 */
function SearchEmptyState({ query = '', translation = {} }) {
  const accessibilityMessage = query
    ? (
        translation.search_accessibility_no_results ||
        'No results found for {query}. Try searching by city name, zip code, pantry name, or street address.'
      ).replace('{query}', query)
    : translation.search_accessibility_no_results_generic ||
      'No results found. Try searching by city name, zip code, pantry name, or street address.';

  const noPantriesMatch = (translation.search_no_pantries_match || 'No pantries match "{query}"').replace(
    '{query}',
    query
  );

  return (
    <View style={styles.container} accessibilityLabel={accessibilityMessage} accessibilityRole="text">
      <Text style={styles.title} accessibilityRole="header">
        {translation.search_no_results_found || 'No results found'}
      </Text>
      {query && (
        <Text style={styles.subtitle} accessibilityLabel={noPantriesMatch}>
          {noPantriesMatch}
        </Text>
      )}
      <Text style={styles.suggestion} accessibilityRole="header">
        {translation.search_try_searching_by || 'Try searching by:'}
      </Text>
      <Text
        style={styles.suggestionItem}
        accessibilityLabel={
          translation.search_suggestion_city_accessibility || 'City name, for example, Brooklyn'
        }
      >
        • {translation.search_suggestion_city || 'City name (e.g., "Brooklyn")'}
      </Text>
      <Text
        style={styles.suggestionItem}
        accessibilityLabel={
          translation.search_suggestion_zipcode_accessibility || 'Zip code, for example, 10001'
        }
      >
        • {translation.search_suggestion_zipcode || 'Zip code (e.g., "10001")'}
      </Text>
      <Text
        style={styles.suggestionItem}
        accessibilityLabel={translation.search_suggestion_pantry_name || 'Pantry name'}
      >
        • {translation.search_suggestion_pantry_name || 'Pantry name'}
      </Text>
      <Text
        style={styles.suggestionItem}
        accessibilityLabel={translation.search_suggestion_street_address || 'Street address'}
      >
        • {translation.search_suggestion_street_address || 'Street address'}
      </Text>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    padding: 32,
    paddingTop: 64,
  },
  title: {
    fontSize: 20,
    fontWeight: '600',
    color: Colors.darkText || '#333',
    marginBottom: 8,
    textAlign: 'center',
  },
  subtitle: {
    fontSize: 16,
    color: Colors.grayText || '#666',
    marginBottom: 24,
    textAlign: 'center',
  },
  suggestion: {
    fontSize: 16,
    fontWeight: '500',
    color: Colors.darkText || '#333',
    marginBottom: 12,
    textAlign: 'center',
  },
  suggestionItem: {
    fontSize: 14,
    color: Colors.grayText || '#666',
    marginBottom: 4,
    textAlign: 'center',
  },
});

SearchEmptyState.propTypes = {
  query: PropTypes.string,
  translation: PropTypes.object,
};

export default SearchEmptyState;
